<script setup lang="ts">
import { Icon, IconName } from '@collector/shared-ui'

interface Props {
  title: string
  icon: IconName
  description: string
}

defineProps<Props>()
</script>

<template>
  <div class="text-neutral-dark-3/60 grid place-content-center">
    <div
      class="bg-neutral-dark-3/20 mx-auto grid h-[4.75rem] w-[4.75rem] place-content-center rounded-full"
    >
      <Icon
        :icon
        size="2x"
      />
    </div>
    <div class="text-center">
      <div class="py-3 text-sm font-bold">
        {{ title }}
      </div>
      <div class="text-sm">
        {{ description }}
      </div>
    </div>
  </div>
</template>
